import type { StockHeaderItem } from "@/lib/gql/__generated__/graphql";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

import { StockTableHeaderItem } from "./item";

type Props = { headers: StockHeaderItem[] };

export const StockTableHeader = ({ headers }: Props) => {
	const date = headers[0]?.date;

	if (!date) {
		notifyUserEventInfo({
			variant: "error",
			title: "システムエラーが発生しました。問い合わせ画面よりお問い合わせください。",
		});
	}

	const year = date.split("-")[0];

	const [_, month] = date.split("-");
	const monthNum = Number(month);

	return (
		<TableHeader>
			<TableRow className="sticky top-0 z-40">
				{/* widthがアイテム名に対応している */}
				<TableHead className="sticky left-0 w-52 bg-white text-base tabular-nums text-zinc-950">
					{year} 年 {monthNum} 月
				</TableHead>

				{headers.map((header) => (
					<StockTableHeaderItem key={`stock-${header.date}`} date={header.date} weekday={header.weekday} />
				))}
			</TableRow>
		</TableHeader>
	);
};

StockTableHeader.displayName = "StockTableHeader";
